var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-do-server-action-button',_vm._b({attrs:{"request":_vm.email,"uri":_vm.uri,"success-message":""},on:{"success":_vm.success}},'o-do-server-action-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }